<template>
  <div
    v-bind:class="['my-4 ma-md-5 mx-lg-10 mx-xl-10 maxw-1750', {
    'px-4': !$vuetify.breakpoint.mdAndUp,
  }]">
    <h2>{{ $t('views.notificationDetails.lisTitle') }}</h2>
    <v-row
      no-gutters
      align="center"
      justify="start"
    >
      <v-sheet
        class="mb-5 mt-1 showWeb"
        :style="{ background: 'none' }"
      >
        <div class="container__chip">
          <span
            v-for="(filterItem, i) of listFilters"
            :key="i"
            :class="[filterItem.active
              ? 'chip__active'
              : '', 'chip__agrupaciones chip__filter v-chip']"
          >
            <span @click="clickChip(filterItem.label)">
              {{ getLabel(filterItem.label) }}
              <!-- {{ $t(`views.notificationDetails.filterItem.${filterItem.label}`) }} -->
            </span>
          </span>
        </div>
      </v-sheet>

      <v-slide-group
        class="showMobile"
        multiple
        show-arrows
      >
        <v-slide-item
          v-for="(filterItem, i) in listFilters"
          :key="i"
          :class="[filterItem.active
            ? 'chip__active'
            : '', 'chip__agrupaciones chip__filter v-chip']"
        >
          <span @click="clickChip(filterItem.label)">
            {{ getLabel(filterItem.label) }}
            <!-- {{ $t(`views.notificationDetails.filterItem.${filterItem.label}`) }} -->
          </span>
        </v-slide-item>
      </v-slide-group>
    </v-row>

    <div class="scroll-container">
      <template v-if="!loading || filteredNotificationsAux.length">
        <v-card v-if="!filteredNotificationsAux.length" class="mt-4">
          <v-card-text class="text-subtitle-2">
            {{$t('views.notificationDetails.empty')}}
          </v-card-text>
        </v-card>

        <template v-else>
          <ListItem
            v-for="(item, i) in filteredNotificationsAux"
            :key="i"
            :url="url(item)"
          >
            <template slot="title">
                <div class="container__notif">
                  <div class="notif__date">
                    <v-card-title class="d-inline notification__title textEllipsis">
                      <span
                      v-if="item.creationDate"
                      class="ml-2 text-body-2 d-inline-block noti__title">
                        {{ item.creationDate }}
                      </span>
                    </v-card-title>

                    <div class="container__chipsTematica--app">
                      <span
                        :key="i"
                        class="chip__active chip__filter chip__filter--tematica v-chip"
                      >
                        <span>
                          {{ getCategory(item.bussinessType) }}
                        </span>
                      </span>
                    </div>
                  </div>

                  <div class="notif__info">
                    <div class="info__subject">
                      <div class="info__avatar notification-card-icon">
                        <div class="pa-2">
                          <v-avatar
                            color=""
                            size="25"
                          >
                            <v-icon dark>{{ getIcon(item.type) }}</v-icon>
                          </v-avatar>
                        </div>
                      </div>

                      <v-card-title class="d-inline notification__title noti__title">
                        {{ item.subject ? item.subject : item.text }}
                      </v-card-title>

                      <v-spacer class="container__chipsTematica--web" />

                      <div class="container__chipsTematica--web">
                        <span
                          :key="i"
                          class="chip__active chip__filter chip__filter--tematica v-chip"
                        >
                          <span>
                            {{ getCategory(item.bussinessType) }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
            </template>
          </ListItem>
        </template>

      </template>
    </div>

    <template  v-if="loading">
      <template v-if="filteredNotificationsAux.length === 0">
        <v-card v-for="i in 7" :key="i * -10" class="mt-4 py-2">
          <v-skeleton-loader
            :key="i"
            type="list-item-avatar"
            class="mx-auto"
          ></v-skeleton-loader>
        </v-card>
      </template>
      <template v-else>
        <v-card class="mt-4 py-2">
          <v-skeleton-loader
            type="list-item-avatar"
            class="mx-auto"
          ></v-skeleton-loader>
        </v-card>
      </template>
    </template>

    <InfiniteScroll
      margin="10px"
      root="html"
      class="mt-4"
      @scrollList="scrollTickets()"
    />

  </div>
</template>

<script>
import { InfiniteScroll, ListItem } from '@/components';

export default {
  props: {
    loading: Boolean,
    type: String,
    bussinessType: String,
    items: {
      type: Array,
      default: () => ([]),
    },
    lastSearchArgs: {
      type: Object,
      default: () => ({}),
    },
    isPagination: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    InfiniteScroll,
    ListItem,
  },
  data: () => ({
    listFilters: [
      {
        label: 'all',
        active: true,
        bussinessType: null,
      },
      {
        label: 'requests',
        active: false,
        bussinessType: ['608a5f0dfdbc36491c995a7b', '608a5f2afdbc36491c995a7c', '6034dbde8c72ae370465467f', '6034dbc08c72ae370465467e', '6034dbe98c72ae3704654680'],
      },
      {
        label: 'interruptions',
        active: false,
        bussinessType: ['62010898d1827bba9cca0a32', '62010887d1827b25cdca0a29'],
      },
      {
        label: 'communications',
        active: false,
        bussinessType: ['6034dbf78c72ae3704654681', '6553677a298f818934dbd312'],
      },
    ],
    countCall: 0,
    filteredNotifications: [],
    filteredNotificationsAux: [],
    typeNotif: 'all',
    page: 1,
  }),
  methods: {
    search(filters = {}, options = {}) {
      const { type } = filters;
      const { target, page } = options; // eslint-disable-line

      this.notificationType = type;
      if (target === 'filter') {
        this.notificationPagination = 0;
      }

      const params = Object.keys(filters) // eslint-disable-line
        .filter((key) => typeof filters[key] === 'string')
        .map((key) => `${key}=${filters[key]}`)
        .join('&');

      if (!this.loading) {
        this.$emit('request', {
          type: 'list',
          args: {
            page: this.page,
          },
        });
      }
    },
    url(item) {
      return `/notifs/${item.id}`;
    },
    /* eslint-disable no-param-reassign */
    clickChip(label) {
      this.typeNotif = label;
      this.listFilters.forEach((filter) => {
        if (filter.label === label) {
          filter.active = !filter.active;
        } else {
          filter.active = false;
        }
      });

      if (label !== 'all') {
        this.filteredNotificationsAux = this.filteredNotifications.filter((item) => this.$getConst(`notificationsView.bussinesType.${label}`).includes(item.bussinessType));
      } else {
        this.filteredNotificationsAux = this.filteredNotifications;
      }
    },
    getCategory(bussinessType) {
      if (this.$getConst('notificationsView.bussinesType.requests').includes(bussinessType)) {
        return this.$t('views.notificationDetails.filterItem.requests');
      }
      if (this.$getConst('notificationsView.bussinesType.interruptions').includes(bussinessType)) {
        return this.$t('views.notificationDetails.filterItem.interruptions');
      }
      if (this.$getConst('notificationsView.bussinesType.communications').includes(bussinessType)) {
        return this.$t('views.notificationDetails.filterItem.communications');
      }
      return 'General';
    },
    getIcon(type) {
      return this.$getConst(`notificationsView.icon.${type}`);
    },
    getLabel(labelAux) {
      let label = '';
      if (labelAux === 'all') {
        label = this.$t('views.notificationDetails.filterItem.all');
      } else if (labelAux === 'requests') {
        label = this.$t('views.notificationDetails.filterItem.requests');
      } else if (labelAux === 'interruptions') {
        label = this.$t('views.notificationDetails.filterItem.interruptions');
      } else if (labelAux === 'communications') {
        label = this.$t('views.notificationDetails.filterItem.communications');
      }

      return label;
    },
    async scrollTickets() {
      if (this.typeNotif === 'all') {
        this.page += 1;
        this.search();
      }
    },
  },
  computed: {
    filters() {
      const { type, bussinessType } = this;
      return { type, bussinessType };
    },
    nextPage() {
      return typeof this.lastSearchArgs.page === 'number' ? this.lastSearchArgs.page + 1 : 0;
    },
  },
  watch: {
    loading(newVal) {
      if (newVal === false) {
        this.filteredNotifications = this.items;
        this.filteredNotificationsAux = this.filteredNotifications;
      }
    },
  },
  mounted() {
    this.search(this.filters, this.lastSearchArgs.page || 0);
  },
};
</script>

<style lang="scss" scoped>
  .notification__title {
    font-size: 1rem;
    padding: 0;
    word-break: normal;
  }
  .textEllipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .container__chip {
    margin-left: 1rem;
  }
  .chip__active {
    color: #27846d !important;
    background-color: #e6f1ee !important;
    border: 1px solid #27846d !important;
  }
  .chip__filter {
    margin: 0.3rem;
    cursor: pointer;
    background: #e0e0e0;
    border-radius: 16px;
    font-size: 14px;
    height: 32px;
    border-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.87);
  }

  .container__chip--notification {
    min-width: 110px;
    display: flex;
    justify-content: end;
  }
  .container__notif {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 0 1rem;
  }
  .container__notif:hover {
    background-color: #eeeeee;
  }
  .notif__date {
    display: flex;
    align-items: center;
  }
  .notif__info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
  }
  .info__subject {
    width: 100%;
    display: flex;
    align-items: center;
    word-break: normal;
  }
  .info__category {
    display: flex;
  }
  .info__avatar div div i:before {
    color: #27846d!important;
  }
  .container__chipsTematica--web {
    display: inherit;
    text-align: center;
    align-items: center;
    width: 9.5rem;
  }
  .container__chipsTematica--app {
    display: none;
  }
  .chip__filter--tematica {
    width: 100%;
    display: grid;
    font-size: 0.8rem;
    height: 1.5rem;
  }
  .noti__title {
    line-height: 1.3;
    font-size: 1rem !important;
  }
  .showMobile {
    display: none !important;
  }
  .showMobile .v-slide-group__next,
  .showMobile .v-slide-group__prev {
    min-width: initial !important;
  }
  .font__size--2 > i:before {
    font-size: 2rem!important;
  }
  @media screen and (max-width: 960px) {
    .container__notif,
    .notif__info {
      display: flex;
      flex-direction: column;
      padding: 0;
    }
    .notif__info {
      align-items: start;
    }
    .notif__date {
      align-items: center;
      justify-content: space-between;
    }
    .info__category {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-top: 0.5rem;
      padding-left: 2.5rem;
    }
    .category__chip {
      justify-content: start;
    }
    .container__chipsTematica--web {
      display: none;
    }
    .container__chipsTematica--app {
      display: inherit;
      text-align: center;
      align-items: center;
      width: 9.5rem;
    }
    .showMobile {
      display: flex !important;
      margin-bottom: 0.5rem;
    }
  }
</style>
